export interface FormState<T> {
    model: T | null;
    status: 'VALID' | 'INVALID' | 'PENDING' | 'DISABLED' | '';
    dirty: boolean;
    errors: any;
}

export function defaultFormState<T>(): FormState<T> {
    return {
        model: null,
        status: '',
        dirty: false,
        errors: {},
    };
}
